import { useState, useEffect, useCallback } from 'react';
import { NotificationService, NotificationData } from '../services/notificationService';

export const useNotifications = () => {
  const [notifications, setNotifications] = useState<NotificationData[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const loadNotifications = useCallback(() => {
    const stored = NotificationService.getStoredNotifications();
    setNotifications(stored);
    setUnreadCount(stored.filter(n => !n.read).length);
  }, []);

  const handleNewNotification = useCallback((payload: any) => {
    const notification: NotificationData = {
      id: Date.now().toString(),
      title: payload.data?.title || payload.notification?.title || 'New Notification',
      body: payload.data?.body || payload.notification?.body || '',
      ticketId: payload.data?.ticketId,
      timestamp: Date.now(),
      read: false,
    };

    NotificationService.saveNotification(notification);
    loadNotifications();
  }, [loadNotifications]);

  const markAsRead = useCallback((notificationId: string) => {
    NotificationService.markAsRead(notificationId);
    loadNotifications();
  }, [loadNotifications]);

  const handleNotificationClick = useCallback((notification: NotificationData) => {
    markAsRead(notification.id);
  }, [markAsRead]);



  useEffect(() => {
    loadNotifications();
    
    const unsubscribe = NotificationService.setupForegroundListener(handleNewNotification);

    // Listen for messages from service worker
    const handleServiceWorkerMessage = (event: MessageEvent) => {
      if (event.data?.type === 'BACKGROUND_NOTIFICATION') {
        handleNewNotification(event.data.payload);
      }
    };

    navigator.serviceWorker?.addEventListener('message', handleServiceWorkerMessage);

    return () => {
      if (unsubscribe) unsubscribe();
      navigator.serviceWorker?.removeEventListener('message', handleServiceWorkerMessage);
    };
  }, [loadNotifications, handleNewNotification]);

  return {
    notifications,
    unreadCount,
    markAsRead,
    handleNotificationClick,
    loadNotifications
  };
};